import { ArticleAttributes } from 'components/facets/ArticleAttributes'
import { currencySymbol } from 'lib/utils'
import { AppCurrency, getDisplayLocationName, InventoryArticle } from 'shared'

export interface PublishChangesEditedCardRowInterface {
  article: InventoryArticle
  currency: AppCurrency
}

export const PublishChangesEditedCardRow = ({
  article,
  currency,
}: PublishChangesEditedCardRowInterface) => {
  const { card } = article
  // const languageToShow = CARD_LANGUAGES_WITH_FLAGS.find(
  //   (language) => language.value === article.idLanguage
  // )
  // const conditionToShow = CONDITIONS_MAP_WITH_LABELS.find(
  //   (condition) => condition.code === article.condition
  // )

  const percentageChangeComparedToStartingPrice = (): number => {
    let diff: number
    if (article.newPrice) {
      const variation = article.newPrice! - article.price
      diff = (variation / article.price) * 100
    } else diff = 0
    return diff
  }
  const priceDiff = percentageChangeComparedToStartingPrice()

  return (
    <>
      <tr className="publish-changes-edited-card-row">
        <td className="card-name">{card.name}</td>
        <td className="standard-width">{card.set}</td>
        <td className="change-width">{<ArticleAttributes article={article} iconHeight={20} />}</td>
        <td className="standard-width">{getDisplayLocationName(article.location)}</td>
        <td className="change-width">
          {article.newQuantity !== undefined && article.newQuantity !== article.quantity ? (
            <span>
              {article.quantity}x <i className="fa-regular fa-arrow-right px-2"></i>{' '}
              {article.newQuantity}x
            </span>
          ) : (
            <span>{article.quantity}x</span>
          )}
        </td>
        <td className="change-width">
          {article.newPrice !== undefined && article.newPrice !== article.price ? (
            <>
              <span>
                {article.price}
                {currencySymbol(currency)} <i className="fa-regular fa-arrow-right px-2"></i>{' '}
                {article.newPrice} {currencySymbol(currency)}
              </span>
            </>
          ) : (
            <span>
              {article.price} {currencySymbol(currency)}
            </span>
          )}
        </td>

        {article.newPrice && (
          <td className="price-width">
            {priceDiff.toFixed(2)}%
            {priceDiff > 0 ? (
              <i className="fa-solid fa-up success-color mx-1"></i>
            ) : (
              <i className="fa-solid fa-down error-color mx-1"></i>
            )}
          </td>
        )}
      </tr>
    </>
  )
}
